module.exports = __webpack_public_path__ + "static/media/carta_14.859cd098.jpg";